import { render } from "./StatusSelector.vue?vue&type=template&id=510662d8"
import script from "./StatusSelector.vue?vue&type=script&lang=js"
export * from "./StatusSelector.vue?vue&type=script&lang=js"
script.render = render

export default script